import { toSafeNumber, toSafeObject, toSafeString } from '@shared/utils';
import getWorkflowRunStepStatusPresentation from '@/lib/getWorkflowRunStepStatusPresentation.js';

// Flattens the hierarchical time-machine node tree into a linear, execution-ordered list of rows (pre-order walk).
// Each row is one discrete step execution and carries its tree depth, status presentation, and payload flags so the
// scrubber, step list, and step-output pane can render directly from selector output.
const flattenWorkflowRunTimeMachineRows = (timeMachineNodes) => {
  const rows = [];

  const walk = (nodes, depth) => {
    if (!Array.isArray(nodes)) {
      return;
    }

    nodes.forEach((node) => {
      const safeNode = toSafeObject(node, null) || {};
      const stepId = toSafeString(safeNode.stepId);
      const stepInstanceId = toSafeString(safeNode.stepInstanceId);
      const status = toSafeString(safeNode.status);
      const presentation = getWorkflowRunStepStatusPresentation(status);
      const request = safeNode.request ?? null;
      const response = safeNode.response ?? null;
      const error = safeNode.error ?? null;

      rows.push({
        id: `${stepInstanceId || stepId || 'step'}-${rows.length}`,
        index: rows.length,
        depth,
        type: toSafeString(safeNode.type),
        stepId,
        stepInstanceId,
        status,
        statusLabel: presentation.label,
        statusVariant: presentation.variant,
        durationMs: toSafeNumber(safeNode.durationMs, null),
        startedAt: safeNode.startedAt || null,
        finishedAt: safeNode.finishedAt || null,
        loopIndex: Number.isInteger(safeNode.loopIndex) ? safeNode.loopIndex : null,
        controlAction: toSafeString(safeNode.controlAction) || null,
        request,
        response,
        error,
        truncation: {
          request: Boolean(safeNode?.truncation?.request),
          response: Boolean(safeNode?.truncation?.response),
          error: Boolean(safeNode?.truncation?.error)
        },
        hasPayload: request !== null || response !== null || error !== null
      });

      walk(safeNode.children, depth + 1);
    });
  };

  walk(timeMachineNodes, 0);

  return rows;
};

export default flattenWorkflowRunTimeMachineRows;
